import { Flex, FlexColMd, Headline2, HorizontalRule } from 'components/Elements';
import { FormCard } from 'components/forms/FormComponents';
import { useElementWidth } from 'hooks/useElementWidth';
import { ActivityType } from 'models/Activity';
import React from 'react';
import styled from 'styled-components';
import { theme } from 'theme';

type ActivityFormCardLayoutProps = {
    title: string;
    onSubmit: React.FormEventHandler<HTMLFormElement>;
    pageOne: JSX.Element;
    pageTwo: JSX.Element;
    activityType: ActivityType;
    renderBottomSection: (opts: { fullWidth: boolean }) => JSX.Element;
};

export function ActivityFormCardLayout({
    title,
    onSubmit,
    pageOne,
    pageTwo,
    renderBottomSection,
}: ActivityFormCardLayoutProps): JSX.Element {
    const [ref, width] = useElementWidth<HTMLFormElement>();

    if (width === undefined) {
        return <WideForm onSubmit={onSubmit} ref={ref} />;
    }

    const fullWidth = width >= 500;

    return (
        <WideForm onSubmit={onSubmit} ref={ref}>
            {fullWidth ? (
                <Flex>
                    <PageOne>
                        <Headline2>{title}</Headline2>
                        {pageOne}
                    </PageOne>
                    <VerticalDivider />
                    <PageTwo>{pageTwo}</PageTwo>
                </Flex>
            ) : (
                <>
                    <Headline2>{title}</Headline2>
                    {pageOne}
                    <HorizontalRule />
                    {pageTwo}
                </>
            )}
            <HorizontalRule />
            {renderBottomSection({ fullWidth })}
        </WideForm>
    );
}

const PageOne = styled(FlexColMd)`
    flex: 1;
`;

const PageTwo = styled(FlexColMd)`
    flex: 1;
    height: 100%;
`;

const WideForm = styled(FormCard)`
    width: 100%;
`;

function VerticalDivider(): JSX.Element {
    return (
        <div
            style={{
                width: '1px',
                backgroundColor: theme.cardBorder,
                height: '100%',
                margin: '0 1rem',
            }}
        />
    );
}
